export default __webpack_public_path__ + "static/media/green.ed761849.png";